// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';



// Config projek utama (etikaf-admin)
const firebaseConfig = {
  apiKey: "AIzaSyB5htBstObXmLn7HKdT9oNiPgDGwQ7zwJE",
  authDomain: "etikaf-admin.firebaseapp.com",
  projectId: "etikaf-admin",
  storageBucket: "etikaf-admin.appspot.com",
  messagingSenderId: "210475893981",
  appId: "1:210475893981:web:6b1368a6579a38872fc734",
  measurementId: "G-R1DDERWF98"
};

// Config projek kedua (asatizah)
const asatizahConfig = {
  apiKey: "AIzaSyCiL16E6jRvlIF4HKaD6Jp-EgxXl6f10ns",
  authDomain: "asatizah-etikaf.firebaseapp.com",
  projectId: "asatizah-etikaf",
  storageBucket: "asatizah-etikaf.firebasestorage.app",
  messagingSenderId: "229047628728",
  appId: "1:229047628728:web:408e233883270a916b954d",
  measurementId: "G-Q21GH77FLD"
};

// Inisialisasi projek utama (etikaf-admin)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const storage = getStorage(app);
const firestore = getFirestore(app);
const auth = getAuth(app);
const db = getFirestore(app); // ikut struktur asal

// Inisialisasi projek kedua (asatizah) - named app
const asatizahApp = getApps().find(app => app.name === 'asatizahApp') ||
  initializeApp(asatizahConfig, 'asatizahApp');

const firestoreAsatizah = getFirestore(asatizahApp);

export {
  auth,
  storage,
  firestore,        // projek utama
  db,               // ikut asal Dato’ Seri
  firestoreAsatizah // projek kedua
};